import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { BookOpenText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const { user, login, ready } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (ready && user) return <Navigate to="/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      toast.error("Email dan password wajib diisi");
      return;
    }
    setBusy(true);
    try {
      await login(email.trim(), password);
      toast.success("Selamat datang");
      nav("/dashboard", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login gagal, coba lagi";
      toast.error(typeof msg === "string" ? msg : "Login gagal");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="h-10 w-10 rounded-md bg-zinc-900 flex items-center justify-center">
            <BookOpenText className="h-5 w-5 text-white" />
          </div>
          <div>
            <div className="text-lg font-display font-semibold text-zinc-900 tracking-tight">Buku Stok</div>
            <div className="text-xs text-zinc-500">Modal &amp; Persediaan</div>
          </div>
        </div>
        <div className="border border-zinc-200 rounded-md p-6 bg-white shadow-sm">
          <h1 className="text-xl font-semibold text-zinc-900 mb-1">Masuk ke akun Anda</h1>
          <p className="text-sm text-zinc-500 mb-5">
            Gunakan email &amp; password owner untuk mengakses aplikasi.
          </p>
          <form onSubmit={onSubmit} className="space-y-3" data-testid="login-form">
            <div>
              <Label htmlFor="login-email">Email</Label>
              <Input
                id="login-email"
                data-testid="login-email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="anda@email.com"
                required
              />
            </div>
            <div>
              <Label htmlFor="login-password">Password</Label>
              <Input
                id="login-password"
                data-testid="login-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            <Button
              type="submit"
              disabled={busy}
              data-testid="login-submit"
              className="w-full bg-zinc-900 hover:bg-zinc-800 h-10 mt-2"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Masuk"}
            </Button>
          </form>
          <div className="flex items-center justify-between mt-5 text-xs text-zinc-500">
            <span>Butuh reset password?</span>
            <a
              href="/forgot-password"
              data-testid="link-forgot-password"
              className="text-zinc-900 font-medium hover:underline"
            >
              Lupa Password
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
